import { Icon as BaseIcon, createIcon } from '@chakra-ui/react';
import { FC, ReactElement } from 'react';

import { rem } from '@bonusly/ds-utils';

import { IconProps, IconSize } from '../types';

type IconSource = (props: any) => ReactElement | null;

interface CreateIconOptions {
	name: string;
}

const sizeToPx = (size: IconSize) => {
	return (
		{
			xs: 16,
			sm: 20,
			md: 24,
			lg: 28,
			xl: 32,
		}[size] ?? 18
	);
};

const getSize = (size: IconSize | number) => {
	if (typeof size === 'string') {
		return rem(sizeToPx(size));
	}

	return size;
};

export const createIconFromBase = (icon: IconSource, { name }: CreateIconOptions) => {
	const Icon: FC<IconProps> = ({ size = 'md', ...rest }) => {
		return <BaseIcon as={icon} boxSize={getSize(size)} strokeWidth={1.5} {...rest} />;
	};

	Icon.displayName = name;

	return Icon;
};

interface CreateIconFromPathOptions {
	displayName: string;
	viewBox: string;
	path?: ReactElement | ReactElement[];
	d?: string;
}

export const createIconFromPath = ({ d, displayName, viewBox, path }: CreateIconFromPathOptions) => {
	const Icon = createIcon({
		d,
		displayName,
		viewBox,
		path,
	});

	return createIconFromBase(Icon, { name: displayName });
};
